import { Candidatura } from "./candidatura.model";
import { Gestor } from "./gestor.model";

export class Eleicao  {
    constructor(
        public id?: number,
        public titulo?: string,
        public descricao?: string,
        public dataHoraInicio?: string,
        public dataHoraFim?: string,
        public statusEleicao?: string,
        public eleicaoEncerrada?: boolean,
        public tipoautentificacao?: string,
        public instrucao?: string,
        public acessoIntegracao?: boolean,
        public aceiteTermo?: string,       
        public logo?:string,
        public termo?: string,
        public mensagem?: string,
        public dataHoraResultado?: Date,
        public gestor?: Gestor,
        public rotaEleicao?: string,
        public enviaEmails?: boolean,
        public rastreabilidade?: boolean,
        public labelAuth1?: string,
        public labelAuth2?: string,
        public placeHolderLogin?: string,
        public temCandidaturas?: boolean,
        public cnpj?: string,
        public temVotoEmBranco?: boolean,
        public temVotoNulo?: boolean,
        public temCancelarVoto?: boolean,
        public candidatosGeraddos?: boolean,
        public temPlanos?: boolean

    ) {   }    
}